/* Quiz link helper (post-Quizell).
 * 1. Passes ad-attribution params (fbclid/gclid/utm_*) from the current page
 *    through to quiz.<apex> links at click time, so the quiz can mint _fbc
 *    and analytics keep the campaign context across the hop.
 * 2. Safety net: legacy Quizell anchors (#quiz-…, #finder-quiz-…) that still
 *    exist in editor-managed content navigate to the quiz instead of dead-
 *    scrolling. window.VP_QUIZ_URL is set in theme.liquid per market.
 * 3. Returning quiz-takers: the quiz mirrors the last completed result code
 *    into an apex-scoped cookie (vp_last_result, robertrokett/vitapack
 *    apps/quiz/src/core/returning.ts). With an empty cart, the header cart
 *    icon takes them back to that result instead of an empty cart page.
 */
(function () {
  var QUIZ_HOST_RE = /^https:\/\/quiz\.(vitapack\.(cz|sk|pl|ro)|myvitapack\.hu)\//;
  var QUIZ_APEX_RE = /^(vitapack\.(cz|sk|pl|ro)|myvitapack\.hu)$/;
  var LEGACY_RE = /^#(quiz-aZC7|finder-quiz-)/;
  var PASS_PARAMS = /^(fbclid|gclid|ttclid|msclkid|gbraid|wbraid|utm_[a-z_]+)$/;
  var RESULT_CODE_RE = /^[A-Za-z0-9_-]{8,100}$/;

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    if (!match) return null;
    try {
      return decodeURIComponent(match[1]);
    } catch (e) {
      return null;
    }
  }

  // The result page for the stored code, or null when the cart icon should
  // behave normally. The cookie is scoped to this storefront's apex, so the
  // result lives on quiz.<this apex> (not VP_QUIZ_URL, which falls back to CZ
  // for languages without a quiz).
  function lastResultUrl(cartLink) {
    var apex = window.location.hostname.replace(/^www\./, '');
    if (!QUIZ_APEX_RE.test(apex)) return null;
    var code = readCookie('vp_last_result');
    if (!code || !RESULT_CODE_RE.test(code)) return null;
    // The quiz handed over a pack that vp-pending-cart.js is about to put in the cart.
    if (readCookie('vp_pending_cart')) return null;
    // Anything already in the cart wins: the customer came to see it.
    var count = cartLink.querySelector('.cart-count-bubble [aria-hidden="true"]');
    if (!count || count.textContent.trim() !== '0') return null;
    return 'https://quiz.' + apex + '/quiz-result?code=' + encodeURIComponent(code);
  }

  function decorated(href) {
    try {
      var url = new URL(href);
      var here = new URLSearchParams(window.location.search);
      here.forEach(function (value, key) {
        if (PASS_PARAMS.test(key) && !url.searchParams.has(key)) {
          url.searchParams.set(key, value);
        }
      });
      return url.toString();
    } catch (e) {
      return href;
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    if (link.id === 'cart-icon-bubble') {
      var plainClick = event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
      var resultUrl = plainClick && lastResultUrl(link);
      if (resultUrl) {
        event.preventDefault();
        window.location.assign(decorated(resultUrl));
      }
      return;
    }
    var href = link.getAttribute('href') || '';
    if (LEGACY_RE.test(href) && window.VP_QUIZ_URL) {
      event.preventDefault();
      window.location.assign(decorated(window.VP_QUIZ_URL));
    } else if (QUIZ_HOST_RE.test(href)) {
      var full = decorated(href);
      if (full !== href) link.setAttribute('href', full);
    }
  });
})();
